import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EditNote from './EditNote';

const EditChot = () => {
  const navigate = useNavigate();
  const [currentNote, setCurrentNote] = useState(''); // Uložení aktuální poznámky
  const [isLoading, setIsLoading] = useState(true); // Stav načítání

  const handleBack = () => {
    navigate('/majitel');
  };

  // Načítání aktuální poznámky při načtení komponenty
  useEffect(() => {
    const fetchNote = async () => {
      try {
        const response = await fetch('/fetchNoteChot.php'); // Endpoint pro načtení poznámky pro Chotěšov
        const data = await response.json();
        setCurrentNote(data.note || ''); // Nastavení poznámky do stavu
        setIsLoading(false); // Ukončit načítání
      } catch (error) {
        console.error('Chyba při načítání poznámky:', error);
        setIsLoading(false); // Ukončit načítání i při chybě
      }
    };

    fetchNote();
  }, []);

  return (
    <div>
      <button
        className="mb-4 bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600"
        onClick={handleBack}
      >
        Zpět
      </button>

      {/* Formulář pro editaci poznámky */}
      <EditNote
        endpoint="/saveChotNote.php"
        deleteEndpoint="/deleteChotNote.php" // Endpoint pro smazání poznámky
        initialNote={currentNote}
      />
    </div>
  );
};

export default EditChot;